/* import __COLOCATED_TEMPLATE__ from './period.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { DayOfWeek } from '@square/dashboard-items-data/models/connect/availability-period/data';
import { inject as service } from '@ember/service';
const KEY_NAME_ENTER = 'Enter';
let Period = (_dec = service('availability/availability-periods-manager'), (_class = class Period extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "availabilityPeriodsManager", _descriptor2, this);
    _defineProperty(this, "id", null);
    if (args.availabilityPeriod) {
      this.id = args.availabilityPeriod.availabilityPeriodModel.idOrTempId();
    }
  }
  get dayLabel() {
    switch (this.args.dayOfWeek) {
      case DayOfWeek.SUN:
        return this.intl.t('sharedUi.day.sunday');
      case DayOfWeek.MON:
        return this.intl.t('sharedUi.day.monday');
      case DayOfWeek.TUE:
        return this.intl.t('sharedUi.day.tuesday');
      case DayOfWeek.WED:
        return this.intl.t('sharedUi.day.wednesday');
      case DayOfWeek.THU:
        return this.intl.t('sharedUi.day.thursday');
      case DayOfWeek.FRI:
        return this.intl.t('sharedUi.day.friday');
      case DayOfWeek.SAT:
        return this.intl.t('sharedUi.day.saturday');
      default:
        return '';
    }
  }
  get isFirstInDay() {
    return this.args.dayIndex === 0;
  }
  get startTime() {
    return this.args.availabilityPeriod?.availabilityPeriodModel.startLocalTime ?? null;
  }
  get endTime() {
    return this.args.availabilityPeriod?.availabilityPeriodModel.endLocalTime ?? null;
  }
  get isDayChecked() {
    return Boolean(this.args.availabilityPeriod);
  }
  get isEndTimeNextDay() {
    if (!this.args.availabilityPeriod) {
      return false;
    }
    return this.args.availabilityPeriod.isEndTimeNextDay;
  }

  // This handles an edge case. If the end time is 23:45:00 we want to prevent adding a new availability period
  get isEndTime1145PM() {
    if (!this.args.availabilityPeriod) {
      return false;
    }
    return this.args.availabilityPeriod.availabilityPeriodModel.endLocalTime === '23:45:00';
  }
  get shouldDisplayAddButton() {
    return this.isDayChecked && !this.isEndTimeNextDay && !this.isEndTime1145PM;
  }
  get shouldDisplayDeleteButton() {
    return !this.args.doesDayHaveOneAvailabilityPeriod && this.isDayChecked;
  }
  onAvailabilityChange({
    value,
    isStart
  }) {
    if (!this.args.availabilityPeriod) {
      return;
    }
    const changeArgs = {
      id: this.args.availabilityPeriod.availabilityPeriodModel.idOrTempId(),
      dayOfWeek: this.args.availabilityPeriod.availabilityPeriodModel.dayOfWeek,
      startLocalTime: this.args.availabilityPeriod.availabilityPeriodModel.startLocalTime,
      endLocalTime: this.args.availabilityPeriod.availabilityPeriodModel.endLocalTime
    };
    if (isStart) {
      changeArgs.startLocalTime = value;
    } else {
      changeArgs.endLocalTime = value;
    }
    this.availabilityPeriodsManager.handleAvailabilityPeriodChange(changeArgs);
  }
  handleCheckboxKeyUp(e) {
    if (e.key !== KEY_NAME_ENTER) {
      return;
    }
    this.args.toggleIsDayChecked();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "availabilityPeriodsManager", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onAvailabilityChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onAvailabilityChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleCheckboxKeyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCheckboxKeyUp"), _class.prototype)), _class));
export { Period as default };